import { render, staticRenderFns } from "./MemoPath.vue?vue&type=template&id=6b80b0fc&"
import script from "./MemoPath.vue?vue&type=script&lang=js&"
export * from "./MemoPath.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports